import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import { filter,map } from 'rxjs/operators';
import {AppState} from '../appstate';
import {WebsocketConfig, WebsocketState, WebsocketStatus} from './';
/**
 * Created by ashok on 13/05/17.
 */

@Injectable()
export class WebsocketDataService {

    constructor(private store: Store<AppState>){}

    public get(): Observable<WebsocketStatus> {
        return this.store.select((appState:any)=>appState.reducers.websocketStatus).pipe(filter(Boolean));
    }
    public getConfig(): Observable<WebsocketConfig> {
        return this.store.select((appState:any)=>appState.reducers.websocketStatus.config).pipe(filter(Boolean));
    }

    public connected(): Observable<boolean> {
        return this.store.select((appState:any)=>appState.reducers.websocketStatus.state).pipe(map(state=>{ return state === WebsocketState.CONNECTED; }))
    }

}